export default {"src":"/_next/static/media/TanThetaChartMobile.72e8ff39.svg","height":434,"width":280,"blurWidth":0,"blurHeight":0};